import type { RedirectRequest } from '@azure/msal-browser'

const baseScopes = ['openid', 'profile', 'email'] as const

export const buildLoginRequest = (): RedirectRequest => {
  const apiScope = import.meta.env.VITE_ENTRA_API_SCOPE?.trim()

  return {
    scopes: apiScope ? [...baseScopes, apiScope] : [...baseScopes],
  }
}
